<template src="./anagraficaAuditFSC.html"></template>

<script>
// Dialog admin per gestire l'anagrafica delle domande di audit FSC (capitoli + requisiti al loro
// interno). Le risposte gia' date "fotografano" pero' codice/domanda/indicazione al momento del
// salvataggio (vedi AuditFSCRepo), quindi modificare qui non riscrive gli audit gia' compilati.
import {
    get_anagrafica_auditFSC,
    salva_capitolo_auditFSC,
    elimina_capitolo_auditFSC,
    salva_requisito_auditFSC,
    elimina_requisito_auditFSC,
} from "@/api/api.auditFSC.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },

    data: () => ({
        loading: false,
        capitoli: [],

        dialogCapitolo: false,
        capitoloEdit: {},

        dialogRequisito: false,
        requisitoEdit: {},
    }),

    watch: {
        dialog(nuovo) {
            if (nuovo) this.caricaDati();
        },
    },

    methods: {
        async caricaDati() {
            this.loading = true;
            const res = await get_anagrafica_auditFSC();
            this.capitoli = res.data || [];
            this.loading = false;
        },

        chiudi() {
            this.$emit("chiudi");
        },

        nuovoCapitolo() {
            this.capitoloEdit = { id: 0, ordine: (this.capitoli.length ? Math.max(...this.capitoli.map((c) => c.ordine)) : 0) + 1, nome: "", attivo: true };
            this.dialogCapitolo = true;
        },

        modificaCapitolo(capitolo) {
            this.capitoloEdit = { ...capitolo };
            this.dialogCapitolo = true;
        },

        async salvaCapitolo() {
            const res = await salva_capitolo_auditFSC(this.capitoloEdit);
            if (res.data === "OK") {
                this.dialogCapitolo = false;
                this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async eliminaCapitolo(capitolo) {
            let confirm = await this.$confirm.open(
                "Elimina capitolo",
                "Disattivare il capitolo <b>" + capitolo.nome + "</b> e tutti i suoi requisiti?<br><br>Non comparira' piu' nei nuovi audit, ma resta visibile negli audit gia' compilati."
            );
            if (!confirm) return;

            const res = await elimina_capitolo_auditFSC(capitolo.id);
            if (res.data === "OK") this.caricaDati();
            else this.$toast.alert(res.data);
        },

        nuovoRequisito(capitolo) {
            const massimoOrdine = capitolo.requisiti.length ? Math.max(...capitolo.requisiti.map((r) => r.ordine)) : 0;
            this.requisitoEdit = { id: 0, capitoloId: capitolo.id, ordine: massimoOrdine + 1, codice: "", domanda: "", indicazione: "", attivo: true };
            this.dialogRequisito = true;
        },

        modificaRequisito(requisito) {
            this.requisitoEdit = { ...requisito };
            this.dialogRequisito = true;
        },

        async salvaRequisito() {
            const res = await salva_requisito_auditFSC(this.requisitoEdit);
            if (res.data === "OK") {
                this.dialogRequisito = false;
                this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async eliminaRequisito(requisito) {
            let confirm = await this.$confirm.open(
                "Elimina requisito",
                "Disattivare il requisito <b>" + (requisito.codice || requisito.domanda) + "</b>?<br><br>Non comparira' piu' nei nuovi audit, ma resta visibile negli audit gia' compilati."
            );
            if (!confirm) return;

            const res = await elimina_requisito_auditFSC(requisito.id);
            if (res.data === "OK") this.caricaDati();
            else this.$toast.alert(res.data);
        },
    },
};
</script>
